/* eslint react/prop-types: off */
import { FormInput, FormInputTextArea } from 'camino-react'
import React, { useState, useEffect } from 'react'
import { map } from 'lodash'

const FreeFormSections = ({
  report,
  setReport,
  fieldsToRender,
  canEdit
}) => {
  const [fields, setFields] = useState({})

  const handleUpdate = (value, key) => {
    const newFields = { ...report }
    newFields[key] = value

    setReport(newFields)
  }

  useEffect(() => setFields(report), [report, fields])

  return (
    <>
      <div className="mb-5">
        {map(fieldsToRender, ({ label, key }) => (
          <FormInput label={label}>
            <FormInputTextArea
              disabled={!canEdit}
              value={report[key]}
              onValue={value => handleUpdate(value, key)}
            />
          </FormInput>
        ))}
      </div>
    </>
  )
}

export default FreeFormSections
